import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: 'us-east-1_B1PnbLYM8',
            userPoolClientId: '11onfhrvcijdm4d0jfh4h86bgk',
        }
    },
    API: {
        REST: {
            dnaAdminApi: {
                endpoint: 'https://api-admin.doneapi.com',
                region: 'us-east-1',
                authorizationType: 'AMAZON_COGNITO_USER_POOLS'
            }
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);